const defaultState = {
  requesting: false,
  error: false,
  result: null,
  isCreate: false
};

export default function token(state = defaultState, action) {
  switch (action.type) {
    case 'GET_TOKEN_REQUESTED':
      return {
        requesting: true,
        error: false,
        result: null,
        isCreate: true
      }
    case 'GET_TOKEN_SUCCEEDED':
      return {
        requesting: false,
        error: false,
        result: action.payload,
        isCreate: true
      }
    case 'GET_TOKEN_FAILED':
      return {
        requesting: false,
        error: true,
        result: action.payload,
        isCreate: true
      }
    default:
      return state
  }
}
